<ng-container>
    <div mat-dialog-title class="mat-dialog-header help-dialog-header">
        <h2 class="dialog-title">
            Important Information for Data Import. Ensuring a Smooth Process.
        </h2>
        <h3 class="dialog-subtitle help-subtitle">
            To make sure your data import goes as smoothly as possible, here's what you need to know and some tips to help you along the way.
        </h3>
    </div>

    <div mat-dialog-content class="help-dialog-content">
        <h4>What to Avoid</h4>
        <span>Steer clear of these common pitfalls to prevent issues during import:</span>
        <ul>
            <li><strong>Plain Text is Best.</strong> Always format your cells as plain text. Spreadsheet software's automatic formatting can cause problems.</li>
            <li><strong>No Formulas, Please.</strong> Before importing, replace all formulas with their resulting values.</li>
            <li><strong>One Crop Type Per Sheet.</strong> Each sheet in your template should only contain data for a single crop type. Make sure to identify it clearly in the sheet name.</li>
            <li><strong>Verify Existing Information.</strong> Double-check all details for Cultivar, Site, Sample, and Evaluation. If our system doesn't find a match, it will create new entries.</li>
        </ul>

        <h4>Tips for Success</h4>
        <span>Follow these suggestions for a more efficient import experience:</span>
        <ul>
            <li><strong>Use Custom Protocols for Templates.</strong> We highly recommend generating your import templates using a custom protocol. Templates based on our base protocol can become very large and difficult to manage.</li>
            <li><strong>One Row Per Sample and Evaluation</strong> If you're adding multiple evaluations to the same sample, simply repeat the row and update the evaluation data in the corresponding columns.</li>
            <li><strong>Read the Header Comments.</strong> These comments provide crucial information, including:</li>
            <ul>
                <li>Which columns are required versus optional.</li>
                <li>Examples of the correct data format, especially for characteristics and measurements.</li>
            </ul>
            <li><strong>Don't Alter Columns.</strong> Please do not remove or rearrange any columns that were generated by the report template.</li>
        </ul>

        <h4>Getting Your Import Results</h4>
        <span>Once your import is complete, you'll receive an email containing:</span>
        <ul>
            <li>
                <strong>An Import Summary.</strong> This document will break down your data and its status (whether it was Created, Updated, or Failed).
            </li>
            <li>
                <strong>An Optional Error Sheet.</strong> If any errors occurred during the import, you'll receive a copy of the problematic sheets. Review the cell comments for specific error details, correct them, and then try importing again.
            </li>
        </ul>

        <h4>Need Help?</h4>
        <span>
            If you experience any failed imports or have questions, don't hesitate to reach out to us at <a class="support-link" href="mailto:support@culteva.pro">support@culteva.pro</a> . We're here to help!
        </span>

    </div>

    <mat-dialog-actions align="end">
        <button mat-flat-button color="primary" mat-dialog-close>Close</button>
    </mat-dialog-actions>
</ng-container>